module.exports = __webpack_public_path__ + "static/img/Rory_Lobb_mobile.3c54ca8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Rory_Lobb_mobile.jpg
// module id = OwGe
// module chunks = 0